import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Avatar } from "../avatar";
import { merchantLinks } from "./menus/links";
import MenuItem from "./MenuItem";
import storage from "../../utils/storage";
import { truncateString } from "../../utils/functions";
import LogoutModal from "../modals/logoutmodal/LogoutModal";
import { LogoutIcon, SidebarIcon } from "../../assests/icons/Icons";

import "./styles.scss";

export const MiniSidebarPage = () => {
  const [logoutModal, setLogoutModal] = useState(false);

  const [menuItems, setMenuItems] = useState([]);


  useEffect(() => {
    const onboarded = JSON.parse(storage.fetch("onboardingDetails")).onboarded;
    const onboardedMenuItems = merchantLinks.filter(
      (item) => item.name !== "Onboarding"
    );
    setMenuItems(onboarded ? onboardedMenuItems : merchantLinks);
    
  }, []);

  let logoImage = "";
  if (storage.fetch("merchantDetails")){
    logoImage = JSON.parse(storage.fetch("merchantDetails")).logoUrl;
  }

  let businessName = "";
  if (storage.fetch("merchantDetails")){
    businessName = JSON.parse(storage.fetch("merchantDetails")).merchantName;
  }

  const toggleLogoutModal = () => {
    setLogoutModal(!logoutModal);
  };

  return (
    <>
      <div className="mini__sidebar">
        <div className="sidebar__brand">
          <Link to="/dashboard/merchant/overview">
            <SidebarIcon />
          </Link>
        </div>
        <div className="merchant__mini">
          <Avatar imageUrl={logoImage} />
          {/* <span className="span">
            <p className="userName">{truncateString(businessName)}</p>
           
          </span> */}
          <h5 className="userRole">Admin</h5>
        </div>
        <div className="sidebar__menu">
          <div className="mini-menu">MENU</div>
          <ul>
            {menuItems.map((link, i) => (
              <MenuItem key={i} item={link} />
            ))}
          </ul>
          <div onClick={toggleLogoutModal} className="sign__out">
            <span>
              <LogoutIcon className="sidebar-Iconr" />
            </span>
          </div>
        </div>
      </div>
      {logoutModal && <LogoutModal closeModal={toggleLogoutModal} />}
    </>
  );
};
